import { render, staticRenderFns } from "./ConfigurarCursoPregrabado.vue?vue&type=template&id=3522a560&scoped=true"
import script from "./ConfigurarCursoPregrabado.vue?vue&type=script&lang=js"
export * from "./ConfigurarCursoPregrabado.vue?vue&type=script&lang=js"
import style0 from "./ConfigurarCursoPregrabado.vue?vue&type=style&index=0&id=3522a560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522a560",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VCard,VDialog,VProgressLinear,VTextField,VTextarea})
